import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export enum MhtRolloutUserType {
  HOLDBACK = "HOLDBACK",
  VARIATION = "VARIATION",
  CONTROL = "CONTROL",
  FORCED_ENABLED = "FORCED_ENABLED",
  FORCED_DISABLED = "FORCED_DISABLED",
  HRT_PROMO_LP_TRAFFIC = "HRT_PROMO_LP_TRAFFIC",
}

export enum WeekPlansRolloutUserType {
  HOLDBACK = "HOLDBACK",
  VARIATION = "VARIATION",
  CONTROL = "CONTROL",
  FORCED_ENABLED = "FORCED_ENABLED",
  FORCED_DISABLED = "FORCED_DISABLED",
}

export type PersistentBrowserFlagsState = {
  mhtRolloutUserType?: MhtRolloutUserType;
  weekPlansRolloutUserType?: WeekPlansRolloutUserType;
};

// Adding this state in order to preserve flags on device instead of preserving them just per session (browser session).
const initialState: PersistentBrowserFlagsState = {
  mhtRolloutUserType: undefined,
  weekPlansRolloutUserType: undefined,
};

const persistentBrowserFlagsSlice = createSlice({
  name: "persistentBrowserFlags",
  initialState,
  reducers: {
    setMhtRolloutUserType(state, action: PayloadAction<MhtRolloutUserType>) {
      return {
        ...state,
        mhtRolloutUserType: action.payload,
      };
    },
    setWeekPlansRolloutUserType(
      state,
      action: PayloadAction<WeekPlansRolloutUserType>
    ) {
      return {
        ...state,
        weekPlansRolloutUserType: action.payload,
      };
    },
  },
});

export const { setMhtRolloutUserType, setWeekPlansRolloutUserType } =
  persistentBrowserFlagsSlice.actions;

export default persistentBrowserFlagsSlice;
